import axiosInstance from './axiosInstance';

const RESULTS_BASE = '/results';
const FACULTY_RESULTS = '/lab-internals/faculty/results';

/** @returns {Promise<Array<{ labId: string, totalScore: number|null, grade: string|null, verdict: string|null, evaluatedAt: string|null }>>} */
export async function getStudentResultsMy() {
  const { data } = await axiosInstance.get(`${RESULTS_BASE}/my`);
  return Array.isArray(data) ? data : [];
}

/** @returns {Promise<Record<string, unknown>>} */
export async function getStudentResultDetail(submissionId) {
  const { data } = await axiosInstance.get(`${RESULTS_BASE}/${submissionId}`);
  return data;
}

/** @returns {Promise<{ status: string }>} */
export async function getSubmissionStatus(submissionId) {
  const { data } = await axiosInstance.get(`${RESULTS_BASE}/${submissionId}/status`);
  return data;
}

/** @returns {Promise<{ success?: boolean, data?: Record<string, unknown> }>} */
export async function postSubmissionReevaluate(submissionId) {
  const { data } = await axiosInstance.post(`${RESULTS_BASE}/${submissionId}/re-evaluate`);
  return data;
}

/**
 * @param {Record<string, string|number|undefined>} params — labId, studentId, grade, verdict, page, limit, sortBy, sortOrder
 */
export async function getFacultyResults(params) {
  const { data } = await axiosInstance.get(FACULTY_RESULTS, { params });
  return data;
}

/** @returns {Promise<Array<Record<string, unknown>>>} Labs created by the faculty (minimal fields). */
export async function getFacultyLabs() {
  const { data } = await axiosInstance.get('/lab-internals/faculty');
  const list = data?.data;
  return Array.isArray(list) ? list : [];
}

/** @returns {Promise<Record<string, unknown>>} */
export async function getFacultyResultsSummary(labId) {
  const safeLabId = String(labId || '').trim();
  const { data } = await axiosInstance.get(`/lab-internals/faculty/${safeLabId}/results-summary`);
  return data;
}

/** @returns {Promise<Record<string, unknown>>} */
export async function getFacultySubmissionReview(submissionId) {
  const { data } = await axiosInstance.get(`${FACULTY_RESULTS}/${submissionId}`);
  return data?.data ?? data;
}

/** @returns {Promise<Record<string, unknown>>} */
export async function postFacultySubmissionOverride(submissionId, body) {
  const { data } = await axiosInstance.post(`${FACULTY_RESULTS}/${submissionId}/override`, body);
  return data?.data ?? data;
}
